<div (click)="blockTextReplacingVis=!blockTextReplacingVis" class="h mb-1 ml-0 cur-pointer">Обработка текста</div>
@if(blockTextReplacingVis){
<div>
@if(model.helpVisible()){
    <div class="help-text ml-0">
        Преобразование Исходного текста в соотстветсвии с выбранным Действием.
    </div>
}
<div (keypress)="onRunKey($event)">
    <div class="mb-1">
        <app-drop-down [items]="actionsList" (selected)="actionSelected($event)" [selectedItemInput]="actionsList[0]"></app-drop-down>
    </div>    

<div class="input-wrapper fullwidth">
    <textarea [(ngModel)]="textSource" id="textSourceEl" rows="10" placeholder="Исходный текст" (keypress)="onRunKey($event, true)" (blur)="onBlur()"></textarea>
    <div class="button-wrapper">
        <button class="btn-1 one" (click)="textSource='';Utilits.focus('textSourceEl');" title="Очистка и фокус">F</button>
        <button class="btn-1 one" (click)="act.do(Actions.addToCopypasteTempPalette, textSource)" title="Добавить в Палитра копипаста временная">P</button>                        
    </div>
</div>

<div [class.inactive]="['invertSlashRemoveQuotes','fileNameFromPath','wordsToSingleWordPascalCase','wordsFirstLetterToUpperCase','wordsFirstLetterToLowerCase'].includes(selectedAction?.key??'')">
    <div class="mb-1">
        <div class="inputs-row-1">
            <div class="input-wrapper horizontal" [class.inactive]="['insertBeforeWords'].includes(selectedAction?.key??'')">
                <input [(ngModel)]="textFind" placeholder="искомый текст" (blur)="onBlur()" id="textFind" class="inp-1"/>
                <div class="button-wrapper">
                    <button class="btn-1 one" (click)="textFind='';Utilits.focus('textFind');" title="Очистка и фокус">F</button>
                    <button class="btn-1 one" (click)="act.do(Actions.addToCopypasteTempPalette, textFind)" title="Добавить в Палитра копипаста временная">P</button>                                
                </div>
            </div>
            <div [class.inactive]="['replacePreserveFirstLetterCase','insertBeforeWords'].includes(selectedAction?.key??'')">
                <input type="checkbox" [(ngModel)]="chkCase" id="chkCase" />
                <label for="chkCase">С учетом регистра</label>
            </div>            
        </div>
    </div>
        <div class="inputs-row-1">
            <div class="input-wrapper horizontal">
                <input [(ngModel)]="textNew" placeholder="новый текст" (blur)="onBlur()" id="textNew" class="inp-1"/>
                <div class="button-wrapper">
                    <button class="btn-1 one" (click)="textNew='';Utilits.focus('textNew');" title="Очистка и фокус">F</button>
                    <button class="btn-1 one" (click)="act.do(Actions.addToCopypasteTempPalette, textNew)" title="Добавить в Палитра копипаста временная">P</button>                                
                </div>
            </div>
            <div class="input-wrapper horizontal">
                <!-- <input [(ngModel)]="textExcept" placeholder="кроме слов (зпт)" (blur)="onBlur()" id="textExcept" class="inp-1"/>
                <div class="button-wrapper">
                    <button class="btn-1 one" (click)="textExcept='';Utilits.focus('textExcept');" title="Очистка и фокус">F</button>
                </div>          -->
            </div>            
        </div>

    <div>
        @if(['betweenRegex1AndRegex2', 'filterLinesByRegex'].includes(selectedAction?.key??'')){
        <div>
            <div class="input-wrapper">
                <textarea [(ngModel)]="textRegex1" rows="1" placeholder="Regexp 1" class="input-style" (blur)="onBlur()"></textarea>
            </div>
        </div>
        }
        @if(['betweenRegex1AndRegex2'].includes(selectedAction?.key??'')) {
        <div>
            <div class="input-wrapper">
                <textarea [(ngModel)]="textRegex2" rows="1" placeholder="Regexp 2" class="input-style" (blur)="onBlur()"></textarea>
            </div>
        </div>
        }
    </div>

    @if(['betweenRegex1AndRegex2','linesToFormatWithoutTransform','wordsToFormatWithoutTransform'].includes(selectedAction?.key??'')){
    <select class="inp-1 group-select mb-1" [(ngModel)]="selectedResultType" (blur)="onBlur()">
        @for(a of resultTypes; track a;){
        <option [value]="a.key">{{a.value}}</option>            
        }
    </select>
    }
</div>


<div class="mb-1">
    <button class="btn-1 left" (click)="run()">ВЫПОЛНИТЬ</button>
    <button class="btn-1" (click)="swapText()" title="поменять местами Результат и Исходный текст">&#8597;</button>
    <button class="btn-1" (click)="copy(textResult)" title="Копировать результат в буфер">КОПИРОВАТЬ РЕЗУЛЬТАТ</button>
    <button class="btn-1" (click)="clearClick()">ОЧИСТИТЬ ВСЕ</button>
</div>
</div>

<div class="input-wrapper fullwidth">
    <textarea [(ngModel)]="textResult" rows="10" placeholder="Результат" (blur)="onBlur()"></textarea>
    <div class="button-wrapper">
        <button class="btn-1 one" (click)="act.do(Actions.addToCopypasteTempPalette, textResult)" title="Добавить в Палитра копипаста временная">P</button>                        
    </div>
</div>
</div>

  @if (model.isAdmin) {

<div id="divScript">
    <b class="cur-pointer" (click)="blockScriptVis=!blockScriptVis">Скрипт</b>
</div>
<div class="mb-1">
    <button class="btn-1 left" (click)="runScript()">ВЫПОЛНИТЬ</button>
    <button class="btn-1" (click)="copy(textScriptResult)">COPY RESULT</button>
    <button class="btn-1" (click)="copy(model.replacingScriptText)">COPY SCRIPT</button>
    <button class="btn-1" (click)="openSnippets()">SNIPPETS</button>
</div>

<div class="code">
    <div (keypress)="onRunScriptKey($event)"
        class="ace-editor-wrapper"
        #editor>
    </div>
    <div class="button-wrapper">
        <button class="btn-1 one" (click)="scriptClearAndFocus()" title="Очистка и фокус">F</button>                
    </div> 
</div>
<div class="input-wrapper fullwidth">
    <textarea [(ngModel)]="textScriptResult" rows="10" placeholder="Результат" id="textScriptResult"></textarea>
    <div class="button-wrapper">
        <button class="btn-1 one" (click)="act.do(Actions.addToCopypasteTempPalette, textScriptResult)" title="Добавить в Палитра копипаста временная">P</button>                        
    </div>
</div>
  }
}